<template>
  <artisio-tabs>
    <lot-overview-tab :sale-info="saleInfo" :active-lot="activeLot"/>
    <b-tab class="bidders-tab">
      <template v-slot:title>
        {{ $t('Available Bidders') }}
      </template>
      <div class="bidders-outer-container pt-2">
        <BiddersTable v-if="saleInfo.uuid" :auction="saleInfo" :delete-permission="'delete_bidder'"
                      :change-permission="'change_bidder'" :exclude-search-fields="['sale_no']"
                      :exclude-columns="['sale_no', 'preferred_clerk', 'language', 'status', 'total_spent']"/>
      </div>
    </b-tab>
  </artisio-tabs>
</template>

<script>
  import ArtisioTabs from "@/core/components/artisio-tabs/ArtisioTabs";
  import BiddersTable from "@/modules/bidders/BiddersTable";
  import {createNamespacedHelpers} from "vuex";
  import LotOverviewTab from "@/modules/live-bids/LotOverviewTab";

  const {mapActions: biddersMapActions} = createNamespacedHelpers('bidders');

  export default {
    name: "LiveBidsRightColumn",
    components: {LotOverviewTab, BiddersTable, ArtisioTabs},
    data() {
      return {
        currentTab: 0,
      }
    },
    props: {
      activeLot: {
        type: Object,
        required: true
      },
      saleInfo: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...biddersMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'liveBids',
        extraFilters: {auction_uuid: this.saleInfo.uuid}
      });
    }
  }
</script>

<style lang="scss" scoped>
  .artisio-tabs {
    max-height: 100%;
    display: flex;

    /deep/ .custom-tabs {
      overflow: hidden;
      flex: 1;
    }

    /deep/ .tab-content {
      height: 90%;
      overflow-x: hidden;
      overflow-y: hidden;
    }
  }

  .bidders-tab {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .bidders-outer-container {
      flex: 1;
      overflow: hidden;

      /deep/ .bidders-table {
        overflow: hidden;
        height: 100%;
        display: flex;

        .artisio-table {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .table-content {
            display: flex;
            overflow: auto;
          }

          .pagination {
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>